import { Checkbox, FormControl, FormControlLabel, Paper } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { OrigemProcesso } from '../../../modelo';
import FiltroImportacaoStore from '../../../store/FiltroImportacaoStore';
import FiltroStore from '../../../store/FiltroStore';

interface IPropsFiltroOrigem {
    importacao?: boolean;
}


class FiltroOrigem extends React.Component<IPropsFiltroOrigem> {
    importacaoLocal = false;

    constructor(props: IPropsFiltroOrigem) {
        super(props);

        this.importacaoLocal = !!props.importacao;

        makeObservable(this, {
            importacaoLocal: observable,
            handlePje: action,
            handleLegado: action
        });
    }

    componentDidUpdate(prevProps: IPropsFiltroOrigem) {
        if (prevProps.importacao !== this.props.importacao) {
            this.importacaoLocal = !!this.props.importacao;
        }
    }

    componentDidMount(): void {
        if (!this.store.origem) {
            this.store.origem = 'PL';
        }
    }

    get store() {
        return this.importacaoLocal ? FiltroImportacaoStore : FiltroStore;
    }

    handlePje = () => {
        if (this.store.origem && this.store.origem.includes('P')) {
            this.store.origem = this.store.origem.replace('P', '') as OrigemProcesso;
        } else {
            if (this.store.origem) {
                this.store.origem = this.store.origem.concat('P') as OrigemProcesso;
            } else {
                this.store.origem = 'P';
            }
        }
    };

    handleLegado = () => {
        if (this.store.origem && this.store.origem.includes('L')) {
            this.store.origem = this.store.origem.replace('L', '') as OrigemProcesso;
        } else {
            if (this.store.origem) {
                this.store.origem = this.store.origem.concat('L') as OrigemProcesso;
            } else {
                this.store.origem = 'L';
            }
        }
    };

    render() {
        return (
            <FormControl fullWidth className='formControlFiltros widthCamposCheck' style={{ display: 'flex' }}>
                <Paper className='paperFiltrosWhite' variant="outlined" sx={{
                    display       : 'flex',
                    flexDirection: 'row !important',
                    marginRight  : '33px',
                    padding       : '10px',
                    backgroundColor: '#093170',
                    color: 'white',
                    borderColor: 'white !important' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{
                                    color: 'white',
                                    '&.Mui-checked': {
                                        color: 'white',
                                    },
                                }}
                                //color='primary'
                                className='checkboxFiltros'
                                onChange={this.handleLegado}
                                checked={this.store.origem?.includes('L')}
                            />
                        }
                        labelPlacement="end"
                        label={'eSIJ'}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{
                                    color: 'white',
                                    '&.Mui-checked': {
                                        color: 'white',
                                    },
                                }}
                                color='primary'
                                className='checkboxFiltros'
                                onChange={this.handlePje}
                                checked={this.store.origem?.includes('P')}
                            />
                        }
                        labelPlacement="end"
                        label={'PJe'}
                    />
                </Paper>
            </FormControl>
        );
    }
}

export default observer(FiltroOrigem);
